import React, { useEffect } from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
import Home from './home';
import OnGroundChallenge from './ongroundchallenge';
import OnLineChallenge from './onlinechallenge';
import thankYou from './thankyou';

const Main = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return (
        <Switch>
            <Route exact path='/' component={Home}></Route>
            <Route exact path='/ongroundchallenge' component={OnGroundChallenge}></Route>
            <Route exact path='/onlinechallenge' component={OnLineChallenge}></Route>
            <Route exact path='/thankyou' component={thankYou}></Route>
        </Switch>
    );
}

export default Main;